var map = {
	"./after_bg.png": 8797,
	"./arrow.png": 8722,
	"./before_bg.png": 4316,
	"./blueRing.png": 695,
	"./bluetooth.png": 2627,
	"./bluetooth_b.png": 9972,
	"./centerBottom.png": 9847,
	"./centerTop.png": 8077,
	"./check.png": 7129,
	"./check_g.png": 4703,
	"./circle.png": 737,
	"./close.png": 6773,
	"./device.png": 7619,
	"./device_g.png": 3385,
	"./icon_rate.png": 1769,
	"./icon_rate_g.png": 4143,
	"./left.png": 2402,
	"./list.png": 6021,
	"./oxygen.png": 6170,
	"./power.png": 3110,
	"./rate.png": 3263,
	"./report.png": 5607,
	"./resistance.png": 806,
	"./right.png": 719,
	"./scan.png": 9466,
	"./speed.png": 3248,
	"./speed_new.png": 1255,
	"./圆形 1 (轮廓) (2).png": 9587,
	"./圆形 1 (轮廓).png": 8576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1642;